import * as React from "react";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import ListGroup from "react-bootstrap/ListGroup";
import Form from "react-bootstrap/Form";
import TimeAgo from 'timeago-react'; 
import { DatagridHelper } from "./DatagridHelper";
import { DatagridColumn, PageState} from "../utils/types";
import StateHelper from "../utils/StateHelper";
import Pivot from "./Pivot";
import dayjs from "../utils/dayjs";

const KEY_INVIS_COLS = "apptap_dash_invisCols";

export const Helper = {

  getInvisibleColumns: function( page : string ): string[] {
    let apptap_dash_invisCols: string = window.localStorage.getItem(KEY_INVIS_COLS + page);
  
    let invisColumnsArray: string[] = [];
    if (apptap_dash_invisCols) {
      invisColumnsArray = apptap_dash_invisCols.split(",");
    }
    return invisColumnsArray;
  },

  setLocalStorageValue(page : string, value : string){
    window.localStorage.setItem(KEY_INVIS_COLS + page,value);    
  },


  setVisible : function(columnId : string, value : boolean , page : string){
    if ( value === false ){
      //make it hidden, add to localstorage list

      //check if already there before adding.
      let invisColumnsArray = this.getInvisibleColumns( page );
      
      if( invisColumnsArray.includes(columnId) === true ) {
        //already added, skip.
        return;
      }

      invisColumnsArray.push(columnId);
      let newValue = invisColumnsArray.join(",");
      this.setLocalStorageValue(page, newValue);
    }
    else {
      //remove the columnid from the list
      let invisColumnsArray = this.getInvisibleColumns( page );

      var filtered = invisColumnsArray.filter(function(value){ 
        return value !== columnId;
      });

      let newValue = filtered.join(",");
      this.setLocalStorageValue(page, newValue);
    }
  }
};

let valuesChanged = false;

function ShowHideColumns(props: any) {
  let invisColumnsArray = Helper.getInvisibleColumns(props.page);

  let checkboxesArray: any = [];
  for (let i = 0; i < props.filteredColumns.length; i++) {
    const column = props.filteredColumns[i];

    if( column.isGroupByColumn === false){
      let isInvisColumn = invisColumnsArray.includes(column.id);

      let keyChk : string = "chk" + column.id;
      let keyLi: string = "chkli" + column.id;
      let obj = (
        <ListGroup.Item  key={keyChk}>
          <Form.Check
            key={keyLi}
            type="checkbox"
            style={{ fontSize: 12 }}
            defaultChecked={!isInvisColumn}
            label={column.name}
            onChange={(e) => onChange(e, column.id)}
          />
        </ListGroup.Item>
      );
      checkboxesArray.push(obj);
    }
  }

  function onChange(event: any, id: string) {
    Helper.setVisible(id, event.target.checked, props.page);

    valuesChanged = true;
  }

  function onHide(event: any) {
    if( valuesChanged ){
      props.setRefresh(Date.now());
    }
    props.setModalShow(false);
    valuesChanged = false;
  }

  return (
    <Modal
      {...props}

      onHide={onHide}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>Show/Hide Columns</Modal.Header>
      <Modal.Body>
        <ListGroup>{checkboxesArray}</ListGroup>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

export function OtherFeaturesPanel(props: any) {
  const [modalShow, setModalShow] = React.useState(false);

  function exportOnClick(e:React.SyntheticEvent<any>) {

    const visibleColumns : DatagridColumn[] =  props.filteredColumns.filter( ( (r : any) => r.visible));

    const columnNamesRow : string = visibleColumns.map( (r : any) => {return '"' + r.name + '"';} ).join(",") + "\n";

    let csvData = "";
    props.rows.map( (row : any) => {    
      return csvData += visibleColumns.map( (col : DatagridColumn) => '"' + DatagridHelper.formatValueForExport( col ,row[col.id] ) + '"') + "\n";
    });

    const csvContent : string = "data:text/csv;charset=utf-8," + columnNamesRow + csvData;
    const encodedUri : string = encodeURI(csvContent);
 
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);

    const pageState : PageState = StateHelper.getPageState();

    const strDateStart = pageState.dateStart.toISOString().split('T')[0];
    const strDateEnd = pageState.dateEnd.toISOString().split('T')[0];
    let pivotBy = pageState.pivotBy ? pageState.pivotBy.split(":")[0] : "";
    if (pivotBy) {
      // _pivot_by_ + camel case to snake case convertion
      pivotBy = "_pivot_by_" + pivotBy.replace(/(.)([A-Z][a-z]+)/, '$1_$2').replace(/([a-z0-9])([A-Z])/, '$1_$2').toLowerCase();
    }

    const fileName = strDateStart + "_" + strDateEnd + pivotBy +  "_apptap_" + props.page + "_export.csv";

    link.setAttribute("download", fileName);
    document.body.appendChild(link); // Required for FF

    link.click(); // This will download the data file named "my_data.csv".
  }

  const dataLastUpdate = dayjs.utc(props.dataLastUpdate);
  const queryTimestamp = dayjs.utc(props.queryTimestamp);
  const pageState : PageState = StateHelper.getPageState();

  return (
    <Row>
      <Col sm={8} className="text-left">
        <div style={{ fontSize: 12  }}>Reporting data updated: <TimeAgo title={"Reporting data updated: " + dataLastUpdate.local().format("YYYY-MM-DD hh:mm:ss") + " (local time)"}  datetime={dataLastUpdate.toDate()}  locale='en_US'/></div>
        <div style={{ fontSize: 12  }}>Last queried: <TimeAgo title={"Last queried: " + queryTimestamp.local().format("YYYY-MM-DD hh:mm:ss") + " (local time)"} datetime={queryTimestamp.toDate()}  locale='en_US'/></div>
        <div style={{ fontSize: 12  }}>Results for: {pageState.dateStart && pageState.dateStart.toISOString().split('T')[0]} to {pageState.dateEnd && pageState.dateEnd.toISOString().split('T')[0]}</div>
      </Col>
      <Col sm={2} className="text-center">
        <Pivot {...props} />
      </Col>

      <Col sm={1} className="text-center">
        <Button 
          style={{ fontSize: 12  }}
          size="sm"
          variant="outline-primary"
          onClick={exportOnClick}
          >
        Export as CSV  
        </Button>
      </Col>
      <Col sm={1} className="text-center">
          {" "}
          <Button
            style={{ fontSize: 12  }}
            size="sm"
            variant="outline-primary"
            disabled={!props.filteredColumns.filter((c:any) => c.visible && !c.isGroupByColumn).length}
            onClick={() => setModalShow(true)}
          >Visible Columns</Button>
          <ShowHideColumns
            page={props.page}
            setRefresh={props.setRefresh}
            filteredColumns={props.filteredColumns}
            show={modalShow}
            setModalShow={setModalShow}
          />
      </Col>
    </Row>
  );
}
